import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ReplaySubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'report-viewer',
  templateUrl: './report-viewer.component.html',
  styleUrls: ['./report-viewer.component.scss']
})
export class ReportViewerComponent implements OnInit {

  private type$ = new ReplaySubject<string>(1);
  private name$ = new ReplaySubject<string>(1);


  url$ = this.type$.pipe(
    switchMap(type => this.name$.pipe(map(name => [type, name]))),
    map(([type, name]) => {
      return this.domSanitizer.bypassSecurityTrustResourceUrl(`${localStorage.getItem('reportServerBaseUrl')}/view/form?viewlet=${encodeURIComponent(name)}`)
    })
  )
  constructor(
    private domSanitizer: DomSanitizer
  ) {

  }

  ngOnInit(): void {

  }

  @Input()
  set type(_: string) {
    this.type$.next(_);
  }

  @Input()
  set name(_: string) {
    this.name$.next(_);

  }

}
